import { IDagKvantitet } from "~app/common/models/dagkvantitet";
import { CommandBase } from "~app/common/services/cqs/commandManager";

export class SetLevorderLeveransradKvantitetCommand extends CommandBase {
    leverantorsorderradId: number;
    periodStart: Date;
    periodEnd: Date;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetLevorderLeveransradKvantitetCommand) => void) {
        super("SetLevorderLeveransradKvantitetCommand");
        init(this);
    }
}
